<script setup lang="ts">
</script>

<template>
  <h1 class="absolute left-4 top-6 text-lg font-bold md:left-8">
    <slot></slot>
  </h1>
</template>
